import { httpClient } from "../../helpers/httpClient";
import { APP_API_URL, APP_API_VERSION } from "../../helpers/configuration";

export default {
  getAutomations({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/automations`;
    return httpClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setAutomations", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getAutomationsReport({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/automations:generateReport`;
    return httpClient
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setAutomationsReport", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  createAutomation({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/automations`;
    return httpClient
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Create error" }, { root: true });
        console.log(error);
      });
  },
  updateAutomation({ commit, state, rootState }, { payload, name }) {
    commit("setLoading", true, { root: true });
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${name}`;
    return httpClient
      .patch(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Update error" }, { root: true });
        console.log(error);
      });
  },
  deleteAutomation({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${payload.name}`;
    return httpClient
      .delete(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Automation deleted" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Delete error" }, { root: true });
        console.log(error);
      });
  }
};
